/*eslint-env node*/
const ICONS = require('./serialized-icons');
const { linkResolver } = require('./link-resolver');

function escapeAttr (value) {
  return String(value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
}

// Mirror React: omit null/undefined attributes, escape the rest.
function attr (attrName, value) {
  return value === null || value === undefined ? '' : ` ${attrName}="${escapeAttr(value)}"`;
}

function renderIcon (iconName) {
  const svg = ICONS[iconName];

  if (!svg) {
    console.warn(`Invalid icon type: ${iconName}`);
    return '';
  }

  return svg;
}

function processContentForIcons (children) {
  let childrenProcessed = children;

  if (/{{(.*?)}}/g.test(children)) {
    childrenProcessed = children.replaceAll(/{{(.*?)}}/g, (str, iconName) => renderIcon(iconName));
  }

  return childrenProcessed;
}

function fixLinkButtonWrapping (childrenUnprocessed) {
  const m = childrenUnprocessed.match(/^(<a [^>]+>)(<span class="Button[^>]+>)(.+)<\/span><\/a>$/);

  if (m) {
    return `${m[2]}${m[1]}${m[3]}</a></span>`;
  }

  return childrenUnprocessed;
}

module.exports = function HtmlSerializer (type, element, content, childrenUnprocessed) {
  let children = childrenUnprocessed;

  if (type === 'paragraph' && element?.spans?.length) {
    children = processContentForIcons(fixLinkButtonWrapping(childrenUnprocessed));

    const span = element.spans.find((s) => {
      return s.type === 'label' && s.start === 0 && s.end === element.text?.length;
    });

    if (span?.data?.label) {
      const className = span.data.label.replace(/[^a-z0-9-]+/ig, () => '-').toLowerCase();
      return `<p${attr('class', className)}>${children}</p>`;
    }
  }

  if (type === 'label' && element?.data?.label === 'Target-Blank') {
    children = processContentForIcons(childrenUnprocessed);

    return `<span>${children.replaceAll('<a ', '<a target="_blank" ')}</span>`;
  }

  if (type === 'label' && element?.data?.label === 'Info-Tooltip') {
    children = processContentForIcons(childrenUnprocessed);

    const className = element.data.label.replace(/[^a-z0-9-]+/ig, () => '-').toLowerCase();

    const theSpan = `<span${attr('class', `${className}-inner`)}>${children}</span>`;

    return `<span${attr('class', className)}>${theSpan}</span>`;
  }

  if (type === 'paragraph' && /\bhref="https:\/\/#/.test(children)) {
    children = processContentForIcons(childrenUnprocessed);
    children = children.replaceAll(/\bhref="https:\/\/#/g, 'href="#');
    children = children.replaceAll(' target="undefined" ', ' ');

    return `<p>${children}</p>`;
  }

  if (/{{(.*?)}}/g.test(children)) {
    children = processContentForIcons(childrenUnprocessed);

    if (type === 'paragraph') {
      return `<p>${children}</p>`;
    }

    if (type === 'label') {
      return `<span>${children}</span>`;
    }

    if (type === 'hyperlink') {
      const { data } = element;
      let { url } = data;
      const { target } = data;

      if (!url && data.id && data.type) {
        url = linkResolver(data);
      }

      return `<a${attr('href', url)}${attr('target', target)}>${children}</a>`;
    }
  }

  return null;
};
